/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


  document.addEventListener("DOMContentLoaded", function () {
    const stickyForm = document.getElementById("StickyProductFormWrapper");
    const stopper = document.getElementById("StickyProductFormStopper");

    if (!stickyForm || !stopper) return;

    const observer = new IntersectionObserver(
      function (entries) {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // Deja de ser sticky
            stickyForm.classList.add("is-stopped");
          } else {
            // Sigue siendo sticky
            stickyForm.classList.remove("is-stopped");
          }
        });
      },
      {
        root: null,
        threshold: 0,
      }
    );

    observer.observe(stopper);
  });
